import { useEffect, useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";

export default function LazyLoadSelect({
    apiFunc,
    onChange = () => {},
    value,
    searchKey,
    optionaLabel = null,
    optionValue = null,
    additionalKeys = [],
    params = {},
    initialLoad = false,
    ...props
}) {
    const [localParams, setLocalParams] = useState(params);
    const [refresh, setRefresh] = useState(false);

    async function loadOptions(search, loadedOptions, { page }) {
        if (!initialLoad) {
            return {
                options: [],
                hasMore: false,
                additional: {
                    page: currentPage + 1,
                },
            };
        }

        const currentPage = page || 1;
        let requestParams = {
            ...localParams,
            page: currentPage,
        };

        if (search) {
            requestParams[searchKey] = search;
        }
        const response = await apiFunc(requestParams);

        const items = response?.data?.data?.items ?? [];
        const formatResponse = items.map((item) => {
            const baseResponse = {
                label: optionaLabel ? item[optionaLabel] : item.title_en,
                value: optionValue ? item[optionValue] : item.id,
            };

            additionalKeys.forEach((key) => {
                if (item[key] !== undefined) {
                    baseResponse[key] = item[key];
                }
            });

            return baseResponse;
        });

        const pagination = response.data?.data?.pagination ?? {};
        const hasMore = !!pagination.next

        return {
            options: formatResponse,
            hasMore: hasMore,
            additional: {
                page: currentPage + 1,
            },
        };
    }

    const style = {
        control: (provided) => ({
            ...provided,
            paddingTop: "1.5px",
            paddingBottom: "1.5px",
            marginTop: "5px",
        }),
    };

    useEffect(() => {
        setLocalParams(params);
        setRefresh((prev) => !prev);
    }, [JSON.stringify(params)]);

    return (
        <AsyncPaginate
            styles={style}
            onChange={onChange}
            value={value}
            loadOptions={loadOptions}
            additional={{
                page: 1,
            }}
            debounceTimeout={300}
            key={refresh}
            {...props}
        />
    );
}
